<template>
  <div class="ms-user-nav">
    <div class="wrap inner ms-flex-middle">
      <img src="@/assets/images/logo.png" class="logo" alt="">
    </div>
    <div class="user-right-box ms-flex-middle">
      <el-dropdown :hide-on-click="false" style="margin-left: 40px;" @command="handleCommand">
        <div class="el-dropdown-link ms-flex-middle">
          <img :src="userInfo.avatar || require('@/assets/images/avatar.png')" class="avatar" alt="">
          <i class="el-icon-arrow-down el-icon--right"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="home">个人中心</el-dropdown-item>
          <el-dropdown-item command="logout">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'MsUserNav',
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    handleLogout() {
      this.$confirm('此操作会退出登录，确定继续？', '提示', {
        type: 'warning'
      }).then(async () => {
        await this.$store.dispatch('user/logout').then(() => {
          this.$message({
            type: 'success',
            message: '退出成功!'
          });
          this.$router.push('/home')
        })
      }).catch(() => {});
    },
    handleCommand(command) {
      if (command == 'logout') {
        this.handleLogout()
      } else if (command == 'home') {
        this.$router.push('/userCenter/index')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ms-user-nav {
  background: #FFFFFF;
  box-shadow: 0px 6px 30px 0px rgba(0,0,0,0.1);
  position: relative;
  .inner {
    height: 100px;
    .logo {
      width: 212px;
    }
  }
  .user-right-box {
    position: absolute;
    top: 0;
    right: 0;
    height: 100px;
    padding-right: 40px;
    .icon-message {
      width: 23px;
      height: 32px;
    }
    .avatar {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      margin-right: 16px;
    }
  }
}
</style>
